import PdfZipItem from "../../components/PdfZipItem";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useGetPropertyReturnQuery } from "../../redux/services/apiHome";

const PropertyReturn = () => {
  const { getText } = useLanguageTranslation();
  const [queryParams, setQueryParams] = useState(null);

  const initialValues = { name: "", year: "" };

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Employee name is required"),
    year: Yup.number()
      .typeError("Year must be a number")
      .min(1900, "Year must be after 1900")
      .max(new Date().getFullYear(), "Year cannot be greater then current year")
      .required("Year is required"),
  });

  const { data: propertyReturnData } = useGetPropertyReturnQuery(queryParams, {
    skip: !queryParams, // skip until user submits
  });

  const handleSubmit = (values, { setSubmitting }) => {
    setQueryParams({ name: values.name, year: values.year });
    setSubmitting(false);

    // simulate API call
    setTimeout(() => {
      setSubmitting(false); // <-- re-enable button
      //   resetForm(); // <-- optional: reset form after submit
    }, 1000);
  };

  //   console.log(propertyReturnData);
  //   console.log(propertyReturnData.status);
  //   console.log(propertyReturnData.data);

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={"images/inner_aboutbann.jpg"}
        title={getText("Property Return", "संपाति विवरणी")}
        titleLink="/about-us/corporate-governance"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Property Return", "संपाति विवरणी")}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="col-12 col-md-4 col-lg-4 mb-3 form-box">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting, resetForm }) => (
                  <Form>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 print-contact1 mb-3">
                        <div className="">
                          <label htmlFor="name" id="name-label">
                            {getText("Name of the Employee", "कर्मचारी का नाम")}
                            <span className="mandatory-field">*</span>
                          </label>
                          <Field
                            type="text"
                            name="name"
                            id="name"
                            className="form-control"
                            aria-labelledby="name-label name-error"
                          />
                          <ErrorMessage name="name">
                            {(errorMsg) => (
                              <div
                                id="name-error"
                                className="error-message"
                                role="alert"
                                aria-live="assertive"
                              >
                                {errorMsg}
                              </div>
                            )}
                          </ErrorMessage>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 print-contact1 mb-3">
                        <div className="">
                          <label htmlFor="year" id="year-label">
                            {getText("Year", "वर्ष")}
                            <span className="mandatory-field">*</span>
                          </label>
                          <Field
                            type="text"
                            name="year"
                            id="year"
                            className="form-control"
                            maxLength={4}
                            pattern="\d{4}"
                            inputMode="numeric"
                          />
                          <ErrorMessage name="year">
                            {(errorMsg) => (
                              <div
                                id="year-error"
                                className="error-message"
                                role="alert"
                                aria-live="assertive"
                              >
                                {errorMsg}
                              </div>
                            )}
                          </ErrorMessage>
                        </div>
                      </div>
                    </div>
                    <div className="center-buttons mt-3">
                      <button
                        type="submit"
                        className="quick-btn"
                        disabled={isSubmitting}
                      >
                        {isSubmitting
                          ? getText("Applying...", "लागू किया जा रहा है...")
                          : getText("Apply", "लागू करें")}
                      </button>
                      <button
                        type="button"
                        className="quick-btn"
                        onClick={() => {
                          resetForm(); // reset Formik form values
                          setQueryParams(null); // clear query params so table hides
                        }}
                      >
                        {getText("Reset", "रीसेट")}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>

            {queryParams && propertyReturnData?.data ? (
              <div className="row">
                <div className="col-12 col-sm-12 col-md-8 col-lg-8 mx-auto mt-4">
                  <div className="table-responsive">
                    <table className="table table-striped custom-table">
                      <thead className="table-dark">
                        <tr>
                          <th>{getText("EMPLOYEE CODE", "कर्मचारी कोड")}</th>
                          <th>{getText("EMPLOYEE NAME", "कर्मचारी नाम")}</th>
                          <th>
                            {getText("EMPLOYEE DOCUMENT", "कर्मचारी दस्तावेज़")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {propertyReturnData.data.length > 0 ? (
                          propertyReturnData.data.map((item, index) => (
                            <tr key={index}>
                              <td
                                data-key={getText(
                                  "EMPLOYEE CODE",
                                  "कर्मचारी कोड"
                                )}
                              >
                                {item?.employee_code}
                              </td>
                              <td
                                data-key={getText(
                                  "EMPLOYEE NAME",
                                  "कर्मचारी नाम"
                                )}
                              >
                                {item?.employee_name}
                              </td>
                              <td
                                className="no-wrap-td"
                                data-key={getText(
                                  "EMPLOYEE DOCUMENT",
                                  "कर्मचारी दस्तावेज़"
                                )}
                              >
                                <div>
                                  <PdfZipItem
                                    title={item?.document?.filename}
                                    filePath={item?.document?.url}
                                    filesize={item?.document?.size_kb}
                                  />
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center">
                              {getText(
                                "No records found",
                                "कोई रिकॉर्ड नहीं मिला"
                              )}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PropertyReturn;
